import { getMiddlewareUrl } from '../middleware/getMiddlewareUrl'

/**
 * Posts chat brand information to the webhook
 * @param {string} uuid - Unique identifier for the chat session
 * @param {string} identifier - Chat version identifier
 * @returns {Promise<void>}
 */
export async function sendChatBrand(uuid, identifier) {
  const BASE_URL = getMiddlewareUrl()

  try {
    if (!uuid || !identifier) {
      console.warn(
        'sendChatBrand: Missing required parameters (uuid or identifier)',
      )
      return
    }

    const response = await fetch(`${BASE_URL}/webhook/livechat/chat_brand`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uuid,
        identifier,
      }),
    })

    if (response.ok) {
      console.info('Chat brand information sent successfully')
    } else {
      console.warn(
        `Failed to send chat brand info: ${response.status} ${response.statusText}`,
      )
    }
  } catch (error) {
    console.error('Error sending chat brand information:', error)
  }
}
